<mat-card>
 
    <mat-card-header>
      <mat-card-title>Business Enquiry</mat-card-title>
    </mat-card-header>


  <mat-card-content class="m-t-1">
                        <app-business-enquiry-form
                            #businessEnquiryForm
                            [model]="model"
                            [phoneTypes]="phoneTypes"
                            (formReady)="onChildFormReady($event)">
                        </app-business-enquiry-form>   
  
                        <app-feedback 
                            #feedbackForm
                            [model]="model"
                            [formTypes]="formTypes"
                            (formReady)="onChildFormReady($event)">
                        </app-feedback>
                        <app-data-protection  
                            #dataProtectionForm
                            [model]="model"                        
                            (formReady)="onChildFormReady($event)">
                        </app-data-protection>

  </mat-card-content>
</mat-card>